import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn as clsx } from "../../helpers/react.js";
import { Font } from "../Font/index.js";
import '../../assets/index6.css';const avatar = "_avatar_15if8_1";
const circle = "_circle_15if8_15";
const square = "_square_15if8_21";
const green = "_green_15if8_27";
const lime = "_lime_15if8_31";
const peru = "_peru_15if8_35";
const teal = "_teal_15if8_39";
const skyBlue = "_skyBlue_15if8_43";
const lightBlue = "_lightBlue_15if8_47";
const neonBlue = "_neonBlue_15if8_51";
const violet = "_violet_15if8_55";
const darkViolet = "_darkViolet_15if8_59";
const disabled = "_disabled_15if8_63";
const s = {
  avatar,
  circle,
  square,
  green,
  lime,
  peru,
  teal,
  skyBlue,
  lightBlue,
  neonBlue,
  violet,
  darkViolet,
  disabled
};
const colors = {
  green: s.green,
  lime: s.lime,
  peru: s.peru,
  teal: s.teal,
  skyBlue: s.skyBlue,
  lightBlue: s.lightBlue,
  neonBlue: s.neonBlue,
  violet: s.violet,
  darkViolet: s.darkViolet,
  disabled: s.disabled
};
const Avatar = forwardRef((props, ref) => {
  const { shape, ...newProps } = props;
  newProps.className = clsx(
    props.className,
    s.avatar,
    shape === "circle" ? s.circle : s.square,
    "text" in props ? colors[props.color] : null
  );
  let content;
  if ("src" in props) {
    content = /* @__PURE__ */ jsx("img", { src: props.src, alt: "avatar" });
  } else {
    content = props.text.substring(0, shape === "circle" ? 2 : 3);
  }
  return /* @__PURE__ */ jsx(Font, { type: "text", size: shape === "circle" ? 14 : 16, weight: "medium", children: /* @__PURE__ */ jsx("span", { ...newProps, ref, children: content }) });
});
export {
  Avatar,
  colors
};
